import {
  
  aggregateToolsAndMaterialsFromSteps
} from './aggregate-step-resources'
import type {AggregatedStepResources} from './aggregate-step-resources';
import type { ProjectTemplate, TemplateStep } from '../types'

type TemplateLevelTool = {
  customName?: string
  name?: string
  required?: boolean
}

type TemplateLevelMaterial = {
  customName?: string
  name?: string
  estimatedCost?: number
  quantity?: number
  unit?: string
}

/**
 * Merge template-level tools/materials with step-level rollup (dedupe by name).
 */
export function aggregateToolsAndMaterialsFromTemplate(
  template: Pick<ProjectTemplate, 'steps'> & {
    tools?: Array<TemplateLevelTool>
    materials?: Array<TemplateLevelMaterial>
  },
  steps: Array<TemplateStep> = template.steps,
): AggregatedStepResources {
  const fromSteps = aggregateToolsAndMaterialsFromSteps(steps)
  const toolsMap = new Map(fromSteps.tools.map((t) => [t.name, t]))
  const materialsMap = new Map(fromSteps.materials.map((m) => [m.name, m]))

  for (const tool of template.tools ?? []) {
    const name = tool.name ?? tool.customName
    if (!name) continue
    const existing = toolsMap.get(name)
    toolsMap.set(name, {
      name,
      required: existing?.required || tool.required === true,
    })
  }

  for (const material of template.materials ?? []) {
    const name = material.name ?? material.customName
    if (!name) continue
    materialsMap.set(name, {
      name,
      cost: material.estimatedCost,
      quantity: material.quantity,
      unit: material.unit,
    })
  }

  return {
    tools: Array.from(toolsMap.values()),
    materials: Array.from(materialsMap.values()),
  }
}
